/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injector} from '@angular/core';
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceAction,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {NetworkInfoResource, NetworkResource} from './network.resource.token';
import {LOCAL_USER_PROFILE} from '../../../session/session-profile.tokens';

export {NetworkInfoResource, NetworkResource} from './network.resource.token';

// LocalNetworkProfile depends on NetworkResource, and LocalUserProfile sits behind
// LocalNetworkProfile (via LocalUserPermissions). Do not import LocalUserProfile here —
// that creates an ES-module cycle. Resolve via LOCAL_USER_PROFILE token instead.
export function createNetworkInfoResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  injector: Injector
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const NetworkInfo = createAdnHttpResource(send, 'networkinfo', () => injector.get(LOCAL_USER_PROFILE), 'networkInfo');
  const uri = ApiConfig.obtain().getVersionedUri('networkinfo');

  NetworkInfo.chainCounts = createAdnHttpResourceAction(send, {
    method: 'GET',
    url: uri + '/chaincounts',
    queryParams: ['startLevel', 'endLevel', 'delivering', 'readyToDeliver', 'page', 'pageSize'],
    hasBody: false
  });

  return NetworkInfo;
}

export function createNetworkResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  injector: Injector
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'networks', () => injector.get(LOCAL_USER_PROFILE));
}

export const networkInfoResourceProvider = {
  provide: NetworkInfoResource,
  useFactory: createNetworkInfoResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, Injector]
};

export const networkResourceProvider = {
  provide: NetworkResource,
  useFactory: createNetworkResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, Injector]
};

